import { useEffect } from "react";
import { useTranslation } from "react-i18next";
import { type NeedDto } from "../../../autogen/bff-api";
import { CombinedDocuments } from "../../../common/documents/CombinedDocuments";
import { isIncompleteFileUpload, type IncompleteFileUpload } from "../../../common/documents/UppyUploader/FileRow";
import { useUppyUploader } from "../../../common/documents/UppyUploader/useUppyUploader";

interface Props {
  need: NeedDto;
  refetch: () => void;
  canEdit: boolean;
}

export const NeedDocuments = ({ need, refetch, canEdit }: Props) => {
  const { t } = useTranslation();
  const { uppy, allFiles, documents, setDocuments, removeUpload } = useUppyUploader({
    entityId: need.id,
    entityType: "Need",
    reloadEntity: refetch,
  });

  useEffect(() => {
    setDocuments(need.documents ?? []);
  }, [need.documents, setDocuments]);

  return (
    <CombinedDocuments
      uploadedDocuments={documents}
      setUploadedDocuments={setDocuments}
      canEditDocumentNames={canEdit}
      canDeleteDocuments={canEdit}
      documentUploadConfig={
        canEdit
          ? {
              uppy,
              dropTargetId: "needFileTarget",
              dropTargetHelperText: t("Upload relevant documents"),
              uploads: allFiles.filter((f) => isIncompleteFileUpload(f)) as IncompleteFileUpload[],
              removeUpload,
            }
          : undefined
      }
      isTagsColumnVisible={false}
    />
  );
};
